export const TestIds = {
  marqueeItemText: 'marquee-item-text',
};
